import React from "react";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
import "bootstrap-icons/font/bootstrap-icons.css";
import { getUserData } from "../login/LoginSlice";

const moduleMapping = {
  1: {
    key: "1",
    label: "Dashboard",
    icon: <i className="bi bi-pie-chart-fill"></i>,
    path: "Dashboard",
  },
  2: {
    key: "2",
    label: "Enrollment",
    icon: <i className="bi bi-calendar-event"></i>,
    path: "Enrollment",
  },
  3: {
    key: "3",
    label: "Claims",
    icon: <i className="bi bi-calendar-event"></i>,
    path: "Claims",
  },
  4: {
    key: "4",
    label: "Cashless Hospitals",
    icon: <i className="bi bi-hospital-fill"></i>,
    path: "cashless_hospitals",
  },
  5: {
    key: "5",
    label: "Escalation Matrix",
    icon: <i className="bi bi-journal-album"></i>,
    path: "EscalationMatrix",
  },
  6: {
    key: "6",
    label: "Policy Features",
    icon: <i className="bi bi-file-ppt-fill"></i>,
    path: "PolicyFeatures",
  },
  7: {
    key: "7",
    icon: <i className="bi bi-file-earmark-fill"></i>,
    label: "Documents",
    path: "Document",
  },
  8: {
    key: "8",
    icon: <i className="bi bi-calendar-event"></i>,
    label: "CD & Endorsements",
    path: "endorsement_list",
  },
  9: {
    key: "9",
    label: "Employee",
    icon: <i className="bi bi-calendar-event"></i>,
    path: "EmployeActivity",
  },
  10: {
    key: "10",
    label: "Endorsement Calculation",
    icon: <i className="bi bi-calendar-event"></i>,
    path: "Endorsement",
  },
  11: {
    key: "11",
    label: "Reports",
    icon: <i className="bi bi-calendar-event"></i>,
    path: "Reports",
  },
  12: {
    key: "12",
    label: "Summary",
    icon: <i className="bi bi-calendar-event"></i>,
    path: "Summary",
  },
};

const MenuItems = () => {
  const Data = useSelector(getUserData);
  const module_data = Data?.module_data || [];

  const menuItems = module_data
    ?.filter((module) => moduleMapping[module.module_id])
    .map((module) => {
      const menu = moduleMapping[module.module_id];

      // ✅ Filter active module_option_ids based on selection_status
      const filteredOptionIds = module.module_option_ids
        .map((id, index) => (module.selection_status[index] === 1 ? id : null))
        .filter((id) => id !== null);

      // ✅ If no active options, skip rendering this menu item
      if (filteredOptionIds.length === 0) return null;

      return {
        key: menu.key,
        icon: menu.icon,
        label: (
          <Link
            to={{ pathname: menu.path }}
            state={{ module_option_ids: filteredOptionIds }}
          >
            {menu.label}
          </Link>
        ),
        ...(menu.children && { children: menu.children }),
      };
    })
    .filter((item) => item !== null); // Remove null entries

  return menuItems;
};

export default MenuItems;
